import { render, staticRenderFns } from "./EntityBoardView.vue?vue&type=template&id=4bdbc49b&scoped=true"
import script from "./EntityBoardView.vue?vue&type=script&lang=js"
export * from "./EntityBoardView.vue?vue&type=script&lang=js"
import style0 from "./EntityBoardView.vue?vue&type=style&index=0&id=4bdbc49b&prod&scoped=true&lang=scss"
import style1 from "./EntityBoardView.vue?vue&type=style&index=1&id=4bdbc49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbc49b",
  null
  
)

export default component.exports